export default __webpack_public_path__ + "static/media/UBIcomputer.95d965bd.png";